<svg width="206" height="90" viewBox="0 0 206 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M200.5 74.3723V21.627L7.5 66.8473V74.3723H200.5Z" fill="#E8F5EB"/>
<path opacity="0.05" d="M7.5 21.8818V74.6272" stroke="#1F1F1F" stroke-width="0.299689"/>
<path opacity="0.05" d="M39.668 21.8818V74.6272" stroke="#1F1F1F" stroke-width="0.299689"/>
<path opacity="0.05" d="M71.832 21.8818V74.6272" stroke="#1F1F1F" stroke-width="0.299689"/>
<path opacity="0.05" d="M104 21.8818V74.6272" stroke="#1F1F1F" stroke-width="0.299689"/>
<path opacity="0.05" d="M136.168 21.8818V74.6272" stroke="#1F1F1F" stroke-width="0.299689"/>
<path opacity="0.05" d="M168.332 21.8818V74.6272" stroke="#1F1F1F" stroke-width="0.299689"/>
<path opacity="0.05" d="M200.5 21.8818V74.6272" stroke="#1F1F1F" stroke-width="0.299689"/>
<path d="M7.5 70.5752H38.3579C39.2379 70.5752 40.116 70.4944 40.9813 70.3339L71.852 64.608L104.038 56.6519" stroke="#027A48" stroke-width="1.19876" stroke-linecap="round"/>
<circle cx="103.999" cy="56.3912" r="2.99689" fill="white" stroke="#027A48" stroke-width="1.19876"/>
</svg>
